import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoolingTowerWetForcedDraught = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 120,
	viewBox: "0 0 100.0 120.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 120.0 L 0.0 100.0 L 25.0 0.0 L 75.0 0.0 L 100.0 100.0 L 100.0 120.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 100.0 100.0 L 0.0 100.0 M 14.0 45.0 L 50.0 45.0 L 50.0 55.0 M 40.0 55.0 L 50.0 45.0 L 60.0 55.0 M 42.0 62.5 L 36.0 81.0 M 58.0 62.5 L 64.0 81.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 75,
			rx: 15,
			ry: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgCoolingTowerWetForcedDraught;
